<template>
  <Shimmer
    :loading="isLoading"
    class="shimmer"
    :class="[{ highlighted: isHighlighted }, { 'is-loading': isLoading }]"
    :border-radius="isHighlighted ? 'var(--border-radius)' : '0'"
  >
    <slot></slot>
  </Shimmer>
</template>
<script>
import Shimmer from 'Components/PurchaseFlow/Plans/Shimmer';
export default {
  components: {
    Shimmer
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    isHighlighted: {
      type: Boolean,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.shimmer.is-loading {
  &.highlighted {
    background: var(--gradient-vertical);
    height: 110%;
    transform: translateY(-5%);
  }
  ::v-deep {
    & > div {
      background-color: transparent;
    }
  }
}
</style>
